import React from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Modal , ButtonToolbar} from 'reactstrap';
import Select from 'react-select';
import API from '../../../Common/api';

class HorizontalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            employeeCode: '',
            failedModal: false,
            modalNew: false,
            fullName: '',
            email: '',
            mobile: '',
            city: '',
            role: null,
            city: null,
            inventoryOwner: null,
            warehouses: [],
            warehouses_val: [],
            availableRoles: [],
            availableCity: [],
            availableOwners: [],
            availableWarehouses: [],
            username_val: '',
            password:'',
            errors: {}, // State for error messages
        };
    }

    Failedtoggle= () =>{
      this.setState((prevState) => ({ failedModal: !prevState.failedModal }));
    }

    toggleNew= () =>{
      this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    }

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: '' } });
    };

  

    handleRoleChange = (selectedOption) => {
      this.setState({
          role: selectedOption,
          role_val: selectedOption ? selectedOption.value : '', // Handle case when option is cleared
          errors: { ...this.state.errors, role: '' }
      });
    };

    handleCityChange = (selectedOption) => {
      this.setState({
          city: selectedOption,
          city_val: selectedOption ? selectedOption.value : '', // Handle case when option is cleared
          errors: { ...this.state.errors, city: '' }
      });
    };

    handleRoleInputChange = (inputValue) => {
        
      API.get(`/auth/role-autocomplete/?search=${inputValue}`)
      .then((response) => response.data)
      .then((data) => {
          const arr = data.map(item => ({
              value: item.code,
              label: item.name
          }));
          this.setState({ availableRoles: arr });
      })
      .catch((error) => console.error(error));
       
    };

    handleCityInputChange = (inputValue) => {
        
      API.get(`/location/city-autocomplete/?search=${inputValue}`)
      .then((response) => response.data)
      .then((data) => {
          const arr = data.map(item => ({
              value: item.code,
              label: item.name
          }));
          this.setState({ availableCity: arr });
      })
      .catch((error) => console.error(error));
       
    };

    handleWarehouseInputChange = (inputValue) => {
        if (inputValue) {
            API.get(`/location/warehouse-autocomplete/?search=${inputValue}`)
                .then((response) => response.data)
                .then((data) => {
                    const arr = data.map(item => ({
                        value: item.code,
                        label: item.name
                    }));
                    this.setState({ availableWarehouses: arr });
                })
                .catch((error) => console.error(error));
        }
    };

    handleInvenInputChange = (inputValue) => {
      if (inputValue) {
          API.get(`/customer/inv-autocomplete/?search=${inputValue}`)
              .then((response) => response.data)
              .then((data) => {
                  const arr = data.map(item => ({
                      value: item.code,
                      label: item.name
                  }));
                  this.setState({ availableOwners: arr });
              })
              .catch((error) => console.error(error));
      }
    };

    

    handleOwnerChange = (selectedOption) => {
      this.setState({
          inventoryOwner: selectedOption,
          inventoryOwner_val: selectedOption ? selectedOption.value : '',
          errors: { ...this.state.errors, inventoryOwner: '' }
      });
    };

    handleWarehouseChange = (selectedOptions) => {
        this.setState({ warehouses: selectedOptions });
        const selectedWarehouses = selectedOptions ? selectedOptions.map(option => option.value) : [];
        this.setState({ warehouses_val: selectedWarehouses });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { username, employeeCode, fullName, email, mobile, city, role, inventoryOwner, warehouses } = this.state;

        // Validate all fields
        const errors = {};
        if (!username) errors.username = 'Username is required.';
        if (!employeeCode) errors.employeeCode = 'Employee Code is required.';
        if (!fullName) errors.fullName = 'Full Name is required.';
        //if (!email) errors.email = 'Email is required.';
        //if (!mobile) errors.mobile = 'Mobile is required.';
        if (!city) errors.city = 'City is required.';
        if (!role) errors.role = 'Role is required.';
        if (!inventoryOwner) errors.inventoryOwner = 'Inventory Owner is required.';
        if (warehouses.length === 0) errors.warehouses = 'At least one Warehouse is required.';

        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        this.createUser();
    };

    createUser = () => {
        const payload = {
            "username": this.state.username,
            "employee_code": this.state.employeeCode,
            "fullname": this.state.fullName,
            "role": this.state.role_val,
            "warehouse": this.state.warehouses_val,
            "email": this.state.email,
            "mobile": this.state.mobile,
            "city": this.state.city_val,
            "inv_owner": this.state.inventoryOwner_val
        };

        API.post('/auth/create-employee/', { param: payload })
            .then((response) => response.data)
            .then((data) => {
                console.log(data)

                this.setState({
                    success_message: data[0].message,
                    username_val: data[0].username,
                    password: data[0].password,
                    modalNew: true,
                });

            })
           .catch((error) => {
              console.log(error.response)
                if (error.response.status == "400") {
                    this.setState({
                        failed_message: error.response.data[0].error,
                        failedModal: true,
                    });
                } else {
                    console.log(error);
                }
            });
    }

    render() {
        const { errors, modalNew, failedModal } = this.state;

        return (
            <div className="createuser_container" style={{ width: '100%', margin: '1%' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Row form>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="username">Username</Label>
                                <Input
                                    type="text"
                                    name="username"
                                    id="username"
                                    className="form_text_style"
                                    value={this.state.username}
                                    onChange={this.handleChange}
                                    required
                                />
                                {errors.username && <span style={{ color: 'red' }}>{errors.username}</span>}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="employeeCode">Employee Code</Label>
                                <Input
                                    type="text"
                                    name="employeeCode"
                                    id="employeeCode"
                                    value={this.state.employeeCode}
                                    onChange={this.handleChange}
                                    required
                                />
                                {errors.employeeCode && <span style={{ color: 'red' }}>{errors.employeeCode}</span>}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="fullName">Full Name</Label>
                                <Input
                                    type="text"
                                    name="fullName"
                                    id="fullName"
                                    value={this.state.fullName}
                                    onChange={this.handleChange}
                                    required
                                />
                                {errors.fullName && <span style={{ color: 'red' }}>{errors.fullName}</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="email">Email</Label>
                                <Input
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                   
                                />
                               
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="mobile">Mobile</Label>
                                <Input
                                    type="text"
                                    name="mobile"
                                    id="mobile"
                                    value={this.state.mobile}
                                    onChange={this.handleChange}
                                    
                                />
                               
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="city">City</Label>
                                <Select
                                    name="city"
                                    value={this.state.city}
                                    onChange={this.handleCityChange}
                                    onInputChange={this.handleCityInputChange}
                                    options={this.state.availableCity}
                                    placeholder="Select City"
                                    isClearable
                                    isSearchable
                                />
                                {errors.city && <span style={{ color: 'red' }}>{errors.city}</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row form>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="role">Role</Label>
                                <Select
                                    name="role"
                                    value={this.state.role}
                                    onChange={this.handleRoleChange}
                                    onInputChange={this.handleRoleInputChange}
                                    options={this.state.availableRoles}
                                    placeholder="Select Role"
                                    isClearable
                                    isSearchable
                                />
                                {errors.role && <span style={{ color: 'red' }}>{errors.role}</span>}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="inventoryOwner">Inventory Owner</Label>
                                <Select
                                    name="inventoryOwner"
                                    value={this.state.inventoryOwner}
                                    onChange={this.handleOwnerChange}
                                    onInputChange={this.handleInvenInputChange}
                                    options={this.state.availableOwners}
                                    placeholder="Select Inventory Owner"
                                    isClearable
                                    isSearchable
                                />
                                {errors.inventoryOwner && <span style={{ color: 'red' }}>{errors.inventoryOwner}</span>}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="warehouses">Warehouses</Label>
                                <Select
                                    name="warehouses"
                                    value={this.state.warehouses}
                                    onInputChange={this.handleWarehouseInputChange}
                                    onChange={this.handleWarehouseChange}
                                    options={this.state.availableWarehouses}
                                    isMulti
                                    placeholder="Select Warehouses"
                                />
                                {errors.warehouses && <span style={{ color: 'red' }}>{errors.warehouses}</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <button id="createUserBtn" style={{ backgroundColor: '#FBBB00', borderColor: '#FBBB00', color: 'black', paddingTop: 14, paddingBottom: 14, paddingLeft: 24, paddingRight: 24, marginTop: 10 }} type="submit" color="primary">Submit</button>
                </Form>

                <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
                  <div className="modal__header">
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      style={{ right: 15 }}
                      onClick={this.toggleNew}
                    />
                  </div>
                  <div
                    className="modal__body"
                    style={{ paddingTop: 55, paddingBottom: 20 }}
                  >
                    <span
                      className="lnr lnr-thumbs-up modal__title-icon"
                      style={{ color: "#4ce1b6" }}
                    />
                    <h5>{this.state.success_message} </h5>
                    <span style={{fontWeight: 600, textAlign: 'center'}}> UserName : {this.state.username_val}</span><br/>
                    <span style={{fontWeight: 600,textAlign: 'center'}}> Password : {this.state.password}</span>
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <Button
                      style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                      className="modal_ok"
                      onClick={this.toggleNew}
                    >
                      Ok
                    </Button>
                  </ButtonToolbar>
              </Modal>

              <Modal isOpen={failedModal} backdrop="static" toggle={this.Failedtoggle}>
                <div className="modal__header">
                  <button
                    className="lnr lnr-cross modal__close-btn"
                    type="button"
                    style={{ right: 15 }}
                    onClick={this.Failedtoggle}
                  />
                </div>
                <div
                  className="modal__body"
                  style={{ paddingTop: 55, paddingBottom: 20 }}
                >
                  <span
                    className="lnr lnr-cross-circle modal__title-icon"
                    style={{ color: "red" }}
                  />
                  <h4>{this.state.failed_message} </h4>
                </div>
                <ButtonToolbar className="modal__footer">
                  <Button
                    style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                    className="modal_ok"
                    onClick={this.Failedtoggle}
                  >
                    Ok
                  </Button>
                </ButtonToolbar>
              </Modal>

       
            </div>


        );
    }
}

export default HorizontalForm;
